import { render, staticRenderFns } from "./UserSettingsChangePassword.vue?vue&type=template&id=dbd0b6ac&"
import script from "./UserSettingsChangePassword.vue?vue&type=script&lang=js&"
export * from "./UserSettingsChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbd0b6ac')) {
      api.createRecord('dbd0b6ac', component.options)
    } else {
      api.reload('dbd0b6ac', component.options)
    }
    module.hot.accept("./UserSettingsChangePassword.vue?vue&type=template&id=dbd0b6ac&", function () {
      api.rerender('dbd0b6ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/local/base/UserSettings/UserSettingsChangePassword.vue"
export default component.exports